import { useProduct } from '@backpackjs/storefront';
import { useEffect, useState } from 'react';

import { Image } from '../Image';
import { Markdown } from '../Markdown';
import { Svg } from '../Svg';
import { formatCurrency } from '../../utils/formatCurrency';

export function RechargeSubscriptionWidgetDetails({
  selectedVariant,
  selectedSellingPlan,
  shipsNow,
  shipsRecurringly,
  className,
  widgetType,
  item,
  expandable = false,
}) {
  const product = useProduct();
  const [shipNowImage, setShipNowImage] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (selectedVariant?.image?.src) {
      setShipNowImage(selectedVariant?.image?.src);
    } else if (shipsNow?.image?.src) {
      setShipNowImage(shipsNow?.image?.src);
    } else if (product?.featuredImage?.src) {
      setShipNowImage(product?.featuredImage?.src);
    }
  }, [product, selectedVariant, shipsNow]);

  const frequencyDisplay = selectedSellingPlan?.sellingPlan?.name?.replace(
    'Delivery every ',
    ''
  );

  return (
    (expandable && !show && (
      <button
        type="button"
        className="text-[11px] underline"
        onClick={() => {
          setShow(!show);
        }}
      >
        View Delivery Details
      </button>
    )) || (
      <div
        className={`border border-t-0 border-[#DDE2E7] p-4 text-primary lg:pl-12 ${className}`}
      >
        <button
          type="button"
          className="text-[11px] text-secondary underline"
          onClick={() => {
            setShow(!show);
          }}
        >
          Hide Delivery Details
        </button>
        {shipsNow?.show && (
          <div className={`ships-now ${expandable ? 'mt-4' : ''}`}>
            <h3 className="mb-2 flex border-b border-[#20263533] pb-1 text-xs font-light leading-6">
              Ships Today
            </h3>
            <div className="flex items-center text-[12px] [&_li]:mb-0">
              {shipNowImage && (
                <div>
                  <div className="relative aspect-square h-[63px] w-[63px] md:h-[85px] md:w-[85px]">
                    <Image
                      alt="Ships Now"
                      className="absolute h-full w-full object-contain !mix-blend-multiply"
                      width="60px"
                      height="60px"
                      src={shipNowImage}
                    />
                  </div>
                </div>
              )}

              {shipsNow?.items && (
                <div className="text-[12px] font-light [&_li]:!mb-0 [&_p]:!text-[12px]">
                  {item?.quantity && shipsNow?.items && (
                    <Markdown>
                      {shipsNow?.items.replaceAll('{qty}', item?.quantity)}
                    </Markdown>
                  )}
                  {!item?.quantity && shipsNow?.items && (
                    <Markdown>
                      {shipsNow?.items.replaceAll('{qty}', 1)}
                    </Markdown>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        {shipsRecurringly.show && (
          <div className="ships-recurringly mt-4">
            <div className="mb-2 flex justify-between border-b border-[#20263533] pb-1">
              <h3 className="mr-4 flex text-xs font-light leading-6">
                {` Ships every ${frequencyDisplay}`}
              </h3>
              {widgetType === 'featured' && (
                <div>
                  <span className="text-shadowGray line-through">
                    {formatCurrency(shipsRecurringly?.price)}
                  </span>
                  <span className="ml-4">
                    {formatCurrency(shipsRecurringly?.overridePrice)}
                  </span>
                </div>
              )}
            </div>
            <div className="flex items-center text-[12px] font-light [&_li]:!mb-0">
              {shipsRecurringly?.image?.src && (
                <div>
                  <div className="relative aspect-square h-[63px] w-[63px] md:h-[85px] md:w-[85px]">
                    <Image
                      alt="Autoships"
                      className="absolute h-full w-full object-contain !mix-blend-multiply"
                      width="60px"
                      height="60px"
                      src={shipsRecurringly?.image?.src}
                    />
                  </div>
                </div>
              )}
              <div className="text-[12px] font-light [&_li]:!mb-0 [&_p]:!text-[12px]">
                {item?.quantity && shipsRecurringly?.items && (
                  <Markdown>
                    {shipsRecurringly?.items.replaceAll(
                      '{qty}',
                      item?.quantity
                    )}
                  </Markdown>
                )}
                {!item?.quantity && shipsRecurringly?.items && (
                  <Markdown>
                    {shipsRecurringly?.items.replaceAll('{qty}', 1)}
                  </Markdown>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
}
